import type { RouteObject } from 'react-router';

import { lazy } from 'react';
import { Navigate } from 'react-router';

import { hqRoutes } from './hq';
import { authRoutes } from './auth';
import { errorRoutes } from './error';
import { publicRoutes } from './public';
import { clientRoutes } from './client';
import { dashboardRoutes } from './dashboard';

// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/error/404'));

export const routesSection: RouteObject[] = [
  // 默认进 dashboard（AuthGuard 内部会重定向到登录页）
  { index: true, element: <Navigate to="/dashboard" replace /> },

  // Auth
  ...authRoutes,

  // 公开页面（无需登录）
  ...publicRoutes,

  // Dashboard（hq / agent 子路由将在后续 PR 拆分）
  ...dashboardRoutes,

  // HQ
  ...hqRoutes,

  // Client
  ...clientRoutes,

  // Error
  ...errorRoutes,

  // No match
  { path: '*', element: <Page404 /> },
];
